export default {
    'Noda': 'Noda',
    'Stripe': 'Stripe',
}